import { render } from "./ApiIcon.vue?vue&type=template&id=fdc484a4&scoped=true"
import script from "./ApiIcon.vue?vue&type=script&lang=js"
export * from "./ApiIcon.vue?vue&type=script&lang=js"

import "./ApiIcon.vue?vue&type=style&index=0&id=fdc484a4&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc484a4"]])

export default __exports__